module.exports = (__webpack_require__("49fU"))(208);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
// module id = O27J
// module chunks = 23